module.exports = __webpack_public_path__ + "img/message.9642ed53.svg";